import { privateApi } from '@services/api';
import { FolderDesignationEnum } from '@th-types/uploadImage.type';

export interface UploadUrlResponse {
  s3FileId: number;
  preSignedUrl: string;
  validFor: { seconds: number };
}

export interface DownloadUrlResponse {
  url: string;
  validFor: { seconds: number };
}

export interface UploadUrlPayload {
  designation: FolderDesignationEnum;
  fileName: string;
  contentType: string;
  contentLength: number;
  entityId?: string;
}

export const getUploadUrl = async (
  payload: UploadUrlPayload
): Promise<UploadUrlResponse> => {
  const { data } = await privateApi.post<UploadUrlResponse>(
    'files/upload-url',
    payload
  );
  return data;
};

export const getDownloadUrl = async (
  s3FileId: number,
  designation: FolderDesignationEnum
): Promise<DownloadUrlResponse> => {
  const { data } = await privateApi.get<DownloadUrlResponse>(
    `files/${s3FileId}/download-url`,
    { params: { designation } }
  );
  return data;
};
